import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { LoopBackFilter } from '../../sdk/models';
import { LoopBackAuth } from '../../sdk/services/core/auth.service';
import { PlatformApp } from '../../services/app.service';
import * as _ from "lodash";


@Component({
	selector: 'formly-filter-selector',
	template: `
   			<ng-select *ngIf="items.length > 0"   
   				(data)="value"  
              	[active]="selectedvalues"
              	(data)="refreshValue($event)"
              	(selected)="selected($event)"
              	(removed)="removed($event)"
              	[items]="items"
              	[multiple]="false"
               	[disabled]="to.disabled"
              	placeholder="" >
  			</ng-select>
  `, styleUrls: ['./ng2select.scss']
})

/**
 * To be Used only in Core and Platform for Accessing API Components
 */
export class FilterSelect extends FieldType implements OnInit, OnDestroy {
	_loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
	items: any = [];
	selectedvalues: any = [];
	currentuser;
	appId;
	value: any = {};
	formulae = [];
	modelValues = [];

	constructor(private _LoopBackAuth: LoopBackAuth, private _PlatformApp: PlatformApp) {
		super();
	}

	ngOnInit() {
		if (!this.form['subscriptions'])
			this.form['subscriptions'] = [];

		if (!this.form['newcontrols'])
			this.form['newcontrols'] = {};

		for (var key in this.form.controls)
			this.form['newcontrols'][key] = this.form.controls[key];

		if (this.field['formulae']) {
			this.formulae = this.field['formulae'];
			if (this.field.formControl)
				this.addWatcher(this.field.formControl);
		}

		this.currentuser = this._LoopBackAuth.getCurrentUserData();
		if (PlatformApp.getAppVariable("platformApp"))
			this.appId = PlatformApp.getAppVariable("referenceAppId");
		else
			this.appId = this.currentuser.appId

		if (this.model['dataFields'])
			this.to.options = this.getFilterSelectOptions(this.model['dataFields']);
		else
			this.to.options = [];

		this.setOptionValues('value', 'label');

		this.form['subscriptions'].push(this.formControl.valueChanges.subscribe((updatedValue: any) => {
			if (updatedValue && this.model['dataFields'])
				this.constructFilterOptions(updatedValue, this.model['dataFields']);
		}));
	}

	private setOptionValues(idFieldName, textFieldName) {
		this.items = [];
		if (this.to.options && this.to.options.length && this.to.options.length > 0) {
			for (var i = 0; i < this.to.options.length; i++) {
				if (this.model.id !== this.to.options[i][idFieldName])
					this.items.push({ id: this.to.options[i][idFieldName], text: this.to.options[i][textFieldName] });

				if (this.model[this.key] && this.model[this.key] == this.to.options[i][idFieldName])
					this.selectedvalues = [{ id: this.to.options[i][idFieldName], text: this.to.options[i][textFieldName] }];
			}
			this.items = _.sortBy(this.items, 'text');
			this.field.templateOptions.disabled = false;
		} else
			this.field.templateOptions.disabled = true;
	}

	private getFilterSelectOptions(formfields) {
		let optionFields = [];
		formfields.forEach(function (field) {
			if (field.type !== 'repeatedsection' || field.type !== 'subentity') {
				if (field.templateOptions && field.templateOptions.label)
					optionFields.push({ value: field.key, label: field.templateOptions.label.replace('*', '') });
			}
		});
		return _.sortBy(optionFields, 'label');
	}

	private getFormField(fieldname, formfields) {
		let formField;
		for (let i = 0; i < formfields.length; i++) {
			if (fieldname === formfields[i]['key']) {
				formField = formfields[i];
				break;
			}
		}
		return formField;
	}

	private getFilterOptions(filtertype) {
		let options: any = [];

		switch (filtertype) {
			case 'number':
				options = [
					{ 'label': 'equals', 'value': 'equals' },
					{ 'label': 'is less than', 'value': 'is less than' },
					{ 'label': 'is greater than', 'value': 'is greater than' }
				];
				break;

			case 'boolean':
				options = [
					{ 'label': 'equals to', 'value': 'equals to' },
					{ 'label': 'not equals to', 'value': 'not equals to' }
				];
				break;

			case 'date':
				options = [
					{ 'label': 'is', 'value': 'is' },
					{ 'label': 'is equal to', 'value': 'is equal to' },
					{ 'label': 'is before', 'value': 'is before' },
					{ 'label': 'is after', 'value': 'is after' },
					{ 'label': 'is between', 'value': 'is between' }
				];
				break;

			default:
				options = [
					{ 'label': 'contains', 'value': 'contains' },
					{ 'label': "doesn't contain", 'value': 'does not contain' },
					{ 'label': "is empty", 'value': 'empty' },
					{ 'label': "is not empty", 'value': 'not-empty' }
				];
				break;
		}
		return options;
	}

	private getFilterValues(filtertype) {
		let values: any = [];

		switch (filtertype) {
			case 'boolean':
				values = [
					{ 'label': 'True', 'value': '1' },
					{ 'label': 'False', 'value': '0' }
				];
				break;

			case 'date':
				values = [
					{ 'label': 'Today', 'value': 'today' },
					{ 'label': 'Yesterday', 'value': 'yesterday' },
					{ 'label': 'This week', 'value': 'thisweek' },
					{ 'label': 'Last 7 days', 'value': 'last7days' },
					{ 'label': 'Last  week', 'value': 'lastweek' },
					{ 'label': 'This month', 'value': 'thismonth' },
					{ 'label': 'Last month', 'value': 'lastmonth' }
				];
				break;

			default:
				values = [];
				break;
		}
		return values;
	}

	private setFilterOptions(filtertype) {

		switch (filtertype) {
			case 'date':
				this.model['filtertype'] = 'input';
				this.model['filterValueType'] = 'date';
				this.model['filterConditionOptions'] = this.getFilterOptions('date');
				this.model['filterValueOptions'] = this.getFilterValues('date');
				break;

			case 'number':
				this.model['filtertype'] = 'input';
				this.model['filterValueType'] = 'number';
				this.model['filterConditionOptions'] = this.getFilterOptions('number');
				this.model['filterValueOptions'] = [];
				break;

			case 'text':
				this.model['filtertype'] = 'input';
				this.model['filterValueType'] = 'text';
				this.model['filterConditionOptions'] = this.getFilterOptions('text');
				this.model['filterValueOptions'] = [];
				break;

			case 'boolean':
				this.model['filtertype'] = 'select';
				this.model['filterConditionOptions'] = this.getFilterOptions('boolean');
				this.model['filterValueOptions'] = this.getFilterValues('boolean');
				break;

			case 'select':
				this.model['filtertype'] = 'select';
				this.model['filterConditionOptions'] = this.getFilterOptions('boolean');
				this.model['filterValueOptions'] = [];
				break;

			default:
				this.model['filtertype'] = 'input';
				this.model['filterValueType'] = 'text';
				this.model['filterConditionOptions'] = this.getFilterOptions('text');
				this.model['filterValueOptions'] = [];
				break;
		}
	}

	private constructFilterOptions(selectedvalue, formfields) {
		// console.log('Updated Value: ' + selectedvalue);
		let formField = this.getFormField(selectedvalue, formfields);
		let fieldType = formField.type;
		let fieldSubType = formField.templateOptions.type;
		// console.log('Selected: ' + fieldType + ' ' + fieldSubType);

		// Handle unique cases first
		if (fieldType === 'date' || fieldType === 'dateandtime' || fieldSubType === 'date' || fieldSubType === 'dateandtime') {
			this.setFilterOptions('date');
		} else if (fieldSubType === 'number' || fieldSubType === 'percent' || fieldSubType === 'currency') {
			this.setFilterOptions('number');
		} else {
			switch (fieldType) {
				case 'input-field':
				case 'time':
				case 'geolocation':
				case 'textarea':
				case 'readonly-field':
					this.setFilterOptions('text');
					break;

				case 'checkbox':
					this.setFilterOptions('boolean');
					break;

				case 'picklist-radio':
				case 'picklist-select':
				case 'picklist-lookup':
				case 'select-component':
					this.setFilterOptions('select');
					this.model['filterValueLabel'] = formField.templateOptions.label.replace('*', '');
					this.model['filterValueType'] = formField.templateOptions.type;
					for (var key in formField)
						if (formField.hasOwnProperty(key))
							if (key !== "key" && key !== "type" && key !== "templateOptions" && key !== "expressionProperties")
								this.model[key] = formField[key];
					break;

				case 'default':
					this.setFilterOptions('text');
					break;

			}
		}
	}

	private addWatcher(formControl) {
		this.form['subscriptions'].push(formControl.valueChanges.subscribe((updatedValue: any) => {
			for (var i = 0; i < this.formulae.length; i++) {
				var formula = this.formulae[i];
				if (this.setModelValues(formula['fields'], updatedValue))
					this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
			}
		}));
	}

	private setModelValues(fieldArray, updatedValue) {
		var requiredFieldsExist = true;
		this.modelValues = [];
		for (var j = 0; j < fieldArray.length; j++) {
			if (!this.model[fieldArray[j]]) {
				requiredFieldsExist = false;
				break;
			} else {
				if (fieldArray[j] == this.field.key)
					this.modelValues.push(updatedValue);
				else
					this.modelValues.push(this.model[fieldArray[j]]);
			}
		}
		return requiredFieldsExist;
	}

	private setResults(resultArray, value): void {
		for (var i = 0; i < resultArray.length; i++) {
			var resultField = resultArray[i];
			if (this.form.controls[resultField]) {
				this.form.controls[resultField].setValue(value);

				if (this.form['newcontrols'][resultField] && !this.model[resultField]) {
					this.form.setControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				}
			} else {
				if (this.form['newcontrols'][resultField]) {
					this.form.addControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				} else
					this.model[resultField] = value;
			}
		}
	}

	ngOnDestroy() {
		this.selectedvalues = "";
	}

	public selected(value: any): void {
		if (value && value.id)
			this.formControl.setValue(value.id);

		for (var key in this.form['newcontrols'])
			this.setNewFormControl(key);
	}

	public removed(value: any): void {
		if (value && value.id)
			if (this.model[this.key] && this.model[this.key].length)
				this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
	}

	public typed(value: any): void {
	}

	public refreshValue(value: any): void {
		this.value = value;
	}

	public refreshOptions(value: any): void {
		if (this.model['dataFields'])
			this.to.options = this.getFilterSelectOptions(this.model['dataFields']);
		else
			this.to.options = [];

		this.setOptionValues('value', 'label');
	}

	private setNewFormControl(fieldname) {
		if (this.form['newcontrols'][fieldname])
			if (!this.form.controls[fieldname])
				this.form.addControl(fieldname, this.form['newcontrols'][fieldname]);
			else
				this.form.setControl(fieldname, this.form['newcontrols'][fieldname]);
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectfilter.ts